import React from 'react';
import PropTypes from "prop-types";
import { LazyImageList, withImageLoad } from '../LazyImageList';
import { Client } from '../../client';

const FabricImageList = withImageLoad(
  LazyImageList, Client.getRemarkImageUrl
);

const FabricBody = ({
  fabricEnums,
  selectedFabric,
  selectFabric,
  cleanFabric,
  toggleModal,
  changeFabric,
}) => {

  return (
    fabricEnums.length === 0 ? (
      <div className='lazy-image-list__empty-set'>
        <h3>Тканей не найдено</h3>
      </div>
    ) :
      <FabricImageList
        className='lazy-image-list list--fabric'
        onChange={changeFabric}
        onFabricInfoClicked={toggleModal}
        onFabricHoverIn={selectFabric}
        onFabricHoverOut={cleanFabric}
        value={selectedFabric}
        items={fabricEnums}
      />
  )
}

FabricBody.propTypes = {
  fabricEnums: PropTypes.array.isRequired,
  selectedFabric: PropTypes.object.isRequired,
  selectFabric: PropTypes.func.isRequired,
  cleanFabric: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  changeFabric: PropTypes.func.isRequired,
}

export default FabricBody;